import { withNamespaces } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import KpiCard from './components/KpiCard';
import SummaryWidgetsSkeleton from './components/SummaryWidgetsSkeleton';
import useSummaryWidgets from './hooks/useSummaryWidgets';

const SummaryWidgets = ({
    t,
}) => {
    const {
        isLoading,
        isFetching,
        isError,
        widgets,
    } = useSummaryWidgets({ t });

    if (isLoading || isFetching) {
        return <SummaryWidgetsSkeleton />;
    }

    if (isError || !widgets?.length) {
        return null;
    }

    return (
        <Row className="g-3">
            {widgets.map((widget) => (
                <Col key={widget.key} xs="12" sm="6" md="4" xl="2">
                    <KpiCard
                        icon={widget.icon}
                        title={widget.title}
                        value={widget.value}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default withNamespaces()(SummaryWidgets);
